import React from 'react';

import { SvgIcon } from '@interlayer/js/app/components/common/SvgIcon';

import { useTranslations } from '@core/js/hooks/i18n';
import { clsb } from '@core/js/utils/classNames.util';

import { clsx } from '@interlayer/js/app/utils/clsx.util';

import { useHandlerActionClick } from '../../hooks/useHandlerActionClick';
import { TPromotionProps } from '../../types';
import { ImageBanner } from '../ImageBanner';

import style from './Promotion.scss';

export const Promotion: React.FC<TPromotionProps> = ({
    item,
    isHiddenDescription,
    index,
    isReduceDescription,
    classNames,
    customStyle = {}
}) => {
    const t = useTranslations('playtech.mobile.system.promotion.');
    const handleClick = useHandlerActionClick({ item, config: item.imageConfig, index });
    const buildCls = clsb([style, classNames]);
    const date = item.dateLeft
        ? new Date(item?.dateLeft
            ?.split('.')
            ?.reverse()
            ?.join('.'))
        : null;
    const daysLeft = date && !isNaN(date.getTime())
        ? Math.ceil((date.getTime() - (new Date()).getTime()) / (1000 * 3600 * 24))
        : undefined;

    return (
        <div
            data-testid="Promotion_item"
            className={buildCls(['item'])}
            onClick={handleClick}
            style={{ width: customStyle.width }}
        >
            {daysLeft !== undefined && daysLeft >= 0 && (
                <span className={buildCls(['timeLeftWrapper'])}>
                    <SvgIcon
                        type="clock"
                        width="1.2rem"
                        height="1.2rem"
                        className={buildCls(['icon'])}
                    />

                    {daysLeft || 1}{' '}

                    {t(daysLeft <= 1 ? 'dayLeft' : 'daysLeft')}
                </span>
            )}

            <ImageBanner
                item={item}
                index={index}
                isHiddenDescription={isHiddenDescription}
                classNames={{
                    image: style.image,
                    description: clsx(
                        style.description,
                        { [style.descriptionWrap]: isReduceDescription }
                    ),
                    ...isReduceDescription && { descriptionText: style.descriptionText },
                    btnDraw: style.btnDraw,
                    imageWrap: style.imageWrap
                }}
            />
        </div>
    );
};
